import { Component, Inject, NgZone, OnInit, PLATFORM_ID } from '@angular/core';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { isPlatformBrowser, DatePipe } from '@angular/common';
import { EmitterService } from 'src/app/shared/services/event-service';
import { ToastrService } from 'ngx-toastr';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-comparative',
  templateUrl: './comparative.component.html',
  styleUrls: ['./comparative.component.scss']
})
export class ComparativeComponent implements OnInit {

  private chart: am4charts.XYChart;
  public chart_active: String = 'line';
  public toggleFullScreen: Boolean = false;

  public comparative_devices: any = [];
  public description: String = '';
  public device_location: any = [];
  public curr_tab = 'tab-graph';
  public tab_graph_status: boolean = false;
  public tab_table_status: boolean = false;

  public comparative_table_data: any = [];
  public export_data: any = [];
  public tabular_export_data: any = [];
  public param_data: any = [];

  public param: string = '';
  public param_list: any;
  public data_param_el: String = '';
  public data_param: String = '';

  public date: String = '';
  public fromDate: String = '';

  public date_selection: String = '';
  public from_date_selection: String = '';
  public table_to_date_selection: String = '';
  public table_from_date_selection: String = '';

  public pageSize = 25;
  public page = 1;

  constructor(private dashboardService: DashboardService, private eventEmitter: EmitterService, private toastr: ToastrService, private dataShared: DataSharedService, @Inject(PLATFORM_ID) private platformId, private zone: NgZone) { }

  ngOnInit(): void {
    this.getDashboardSettings()

    this.eventEmitter.listen('groupDevices', () => {
      if (this.dataShared.curr_menu == 'dashboard~comparative') {
        this.comparative_devices = [];
        this.dataShared.panel_devices.map(elem => { this.comparative_devices.push(elem.device_id) });
        this.getSelectedDeviceChartData();

      }
    });

    this.eventEmitter.listen('device_type', (device_type) => {
      this.getFirstDeviceID(device_type);
    });

    this.getFirstDeviceID(this.dataShared.device_type);

    this.getCurrDate();
  }

  getDashboardSettings() {
    let setting_body = {
      action: 'getSettings',
      meta_key: 'config',
      user_id: localStorage.getItem('user'),
      account_id: [localStorage.getItem('account')]
    };

    this.dashboardService.httpPost(setting_body).subscribe((res: any) => {
      if (res.status == 200 && res.data?.config?.length > 0) {
        let config = res.data.config[0];
        let data = JSON.parse(localStorage.getItem('sub_user') == '0' ? config.tab_setting : config.sub_tab_setting);

        this.tab_graph_status = data?.allow_tab?.dashboard?.comparative?.graph || false;
        this.tab_table_status = data?.allow_tab?.dashboard?.comparative?.table || false;
      }
    });
  }

  toggleCard = (e) => this.dataShared.toggleCardFullsreen(e);

  resetSinleDevice() {
    this.date = ''; this.fromDate = ''; this.getCurrDate();
  }

  tabChange($event: NgbTabChangeEvent) {
    this.curr_tab = $event.nextId;
    this.resetSinleDevice();
    this.getSelectedDeviceChartData();
  }

  getCurrDate() {
    let date = new Date();
    let formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    this.date = this.date_selection = this.table_to_date_selection = formattedDate;
    this.fromDate = this.from_date_selection = this.table_from_date_selection = formattedDate;
  }

  getFirstDeviceID(device_type) {
    let body = {
      action: 'getDevices',
      account_id: localStorage.getItem('account'),
      device_type: device_type
    };

    this.dashboardService.httpPost(body).subscribe((res: any) => {
      if (res.status == 200 && res.data?.length > 0) {
        this.paramList(res.data[0].device_id);
      }
    });
  }

  paramList(device_id) {
    let body = {
      action: 'getDeviceByID',
      device_id: [device_id]
    };

    this.dashboardService.httpPost(body).subscribe((res: any) => {
      this.param_list = res.data?.[device_id]?.parameters || [];

      // Find parameter details without for-loop
      const selected = this.param_list.find(p => p.parameter === this.param);
      if (selected) {
        this.description = `${selected.description} ${selected.unit}`;
      }
    });
  }

  // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  getSelectedDeviceChartData() {
    this.dataShared.panel_devices.sort((a, b) => (a.device_id > b.device_id) ? 1 : ((b.device_id > a.device_id) ? -1 : 0))
    if (this.comparative_devices.length < 2 || this.comparative_devices.length > 10) {
      this.toastr.error('Please select at least 2 or maximum 10 devices.');
    } else if (this.param == '') {
      this.toastr.error('Please select any parameter');
    } else {
      this.browserOnly(() => {
        if (this.curr_tab == 'tab-graph') this.getChartData();
        else if (this.curr_tab == 'tab-table') this.getComparativeTableData();
      });
    }
  }

  getChartData() {
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      let mergedMap = new Map<number, any>();
      const buckets = res.data?.buckets || [];

      let deviceKeys = this.comparative_devices;

      buckets.forEach((bucket: any) => {
        const dateBuckets = bucket.date_agg?.buckets || [];
        dateBuckets.forEach((dateBucket: any) => {
          if (dateBucket.key_as_string) {
            let timeMs = new Date(dateBucket.key_as_string).getTime();
            if (!mergedMap.has(timeMs)) {
              let row: any = { id: timeMs };
              deviceKeys.forEach((k: any) => {
                row[`date_${k}`] = new Date(dateBucket.key_as_string);
              });
              mergedMap.set(timeMs, row);
            }
          }
        });
      });

      buckets.forEach((bucket: any) => {
        const key = bucket.key;
        const dateBuckets = bucket.date_agg?.buckets || [];
        dateBuckets.forEach((dateBucket: any) => {
          if (dateBucket.key_as_string) {
            let timeMs = new Date(dateBucket.key_as_string).getTime();
            let val = dateBucket[`val_${this.param}`]?.value;
            if (mergedMap.has(timeMs)) {
              mergedMap.get(timeMs)[`value_${key}`] = val !== null && val !== undefined ? val : null;
            }
          }
        });
      });

      this.param_data = Array.from(mergedMap.values()).sort((a: any, b: any) => a.id - b.id);

      let prop = this.getGraphProp('com_chart', this.param_data);
      this.implementLineChart(prop);
    });

    this.getComparativeTableData();
  }

  getBody() {
    let body: any = {
      action: 'getChartDataByAccount',
      user_id: [localStorage.getItem('user')],
      device_id: this.comparative_devices,
      fixed_interval: '1s',
      parameters: [this.param]
    };

    if (this.fromDate != this.date) {
      body.range = { from: this.fromDate, to: this.date };
    } else {
      body.date = this.fromDate;
    }

    return body;
  }

  getGraphProp(param, param_data) {

    let data = {
      element: '',
      data: param_data,
      interval: {
        'interval': 'second',
        'value': 1
      },
      tooltipFormat: 'HH:mm:ss, d MMMM',
      xScrollbar: false
    };

    if (param == 'com_chart') {
      data.element = 'lineChart'
    }

    return data;
  }

  implementLineChart(data) {

    am4core.useTheme(am4themes_animated);

    this.chart = am4core.create(data.element, am4charts.XYChart);
    this.chart.data = data.data;
    this.chart.colors.step = 2;

    // Create axes
    let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.adapter.remove("getTime");

    // Create series
    this.comparative_devices.forEach((_, index) => {
      let device = this.dataShared.panel_devices[index];
      this.createAxisAndSeries(`value_${device.device_id}`, `date_${device.device_id}`, device.location, index % 2 !== 0);
    });

    // Add legend
    this.chart.legend = new am4charts.Legend();
    // Add cursor
    this.chart.cursor = new am4charts.XYCursor();
  }

  createAxisAndSeries(field, date, name, opposite) {

    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

    let series = this.chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = field;
    series.dataFields.dateX = date;
    series.strokeWidth = 2;
    series.name = name;
    series.tooltipText = "{name}: [bold]{valueY}[/]";
    series.tensionX = 0.8;
    series.showOnInit = true;

    let scrollbarX = new am4core.Scrollbar();
    scrollbarX.marginBottom = 20;
    this.chart.scrollbarX = scrollbarX;

    valueAxis.renderer.line.strokeWidth = 2;
    valueAxis.renderer.line.stroke = series.stroke;
    valueAxis.renderer.labels.template.fill = series.stroke;
    valueAxis.renderer.opposite = opposite;

  }

  implementBarChart(data) {

    am4core.useTheme(am4themes_animated);

    this.chart = am4core.create(data.element, am4charts.XYChart);
    this.chart.data = data.data;
    this.chart.colors.step = 2;

    // Create axes
    let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.adapter.remove("getTime");

    // Create series
    this.comparative_devices.forEach((_, index) => {
      let device = this.dataShared.panel_devices[index];
      this.createBarAxisAndSeries(`value_${device.device_id}`, `date_${device.device_id}`, device.location, index % 2 !== 0);
    });

    // Add legend
    this.chart.legend = new am4charts.Legend();
    // Add cursor
    this.chart.cursor = new am4charts.XYCursor();

  }

  createBarAxisAndSeries(field, date, name, opposite) {

    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

    let series = this.chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = field;
    series.dataFields.dateX = date;
    series.strokeWidth = 2;
    series.name = name;
    series.tooltipText = "{name}: [bold]{valueY}[/]";
    series.showOnInit = true;

    // Add scrollbar
    let scrollbarX = new am4core.Scrollbar();
    scrollbarX.marginBottom = 20;
    this.chart.scrollbarX = scrollbarX;

    // Add cursor

    valueAxis.renderer.line.strokeWidth = 2;
    valueAxis.renderer.line.stroke = series.stroke;
    valueAxis.renderer.labels.template.fill = series.stroke;
    valueAxis.renderer.opposite = opposite;
  }

  getComparativeTableData() {
    this.comparative_table_data = [];
    this.tabular_export_data = [];

    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      const buckets = res.data?.buckets || [];

      let data = buckets.slice(0, this.comparative_devices.length).filter(b => b);
      data.sort((a, b) => (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0));

     
    
      let bucketsArray = data.map(d => d.date_agg?.buckets || []);
      if (bucketsArray.length === 0) return;

      // Extract unique timestamps
      let timestampsMap = new Map<number, string>();
      bucketsArray.forEach((buckets: any) => {
        if (buckets) {
          buckets.forEach((bucket: any) => {
            if (bucket && bucket.key_as_string) {
              let time = new Date(bucket.key_as_string).getTime();
              if (!timestampsMap.has(time)) {
                timestampsMap.set(time, bucket.key_as_string);
              }
            }
          });
        }
      });

      let sortedTimestamps = Array.from(timestampsMap.keys()).sort((a, b) => a - b);

      // Create a set of hashmaps for quick lookup
      let deviceValuesByTime = bucketsArray.map((buckets: any) => {
        let map = new Map<number, any>();
        if (buckets) {
          buckets.forEach((bucket: any) => {
            if (bucket && bucket.key_as_string) {
              let time = new Date(bucket.key_as_string).getTime();
              let val = bucket[`val_${this.param}`]?.value;
              map.set(time, val !== null && val !== undefined ? val : 0);
            }
          });
        }
        return map;
      });

      this.device_location = this.dataShared.panel_devices;

      const datePipe = new DatePipe('en-US');

      sortedTimestamps.forEach(time => {
        let dateVal = new Date(timestampsMap.get(time) as string);
        let exportDate = datePipe.transform(dateVal, 'medium'); // Formats to "MMM d, y, h:mm:ss a"

        let rowData: any = { date: dateVal, values: [] };
        let exportRow: any = { date: exportDate };

        this.comparative_devices.forEach((_, d) => {
          let val = 0;
          if (deviceValuesByTime[d] && deviceValuesByTime[d].has(time)) {
            val = deviceValuesByTime[d].get(time);
          }

          rowData.values.push(val);

          let panelDevice = this.dataShared.panel_devices[d];
          if (panelDevice) {
            exportRow[panelDevice.location] = val;
          }
        });

        this.comparative_table_data.push(rowData);
        this.tabular_export_data.push(exportRow);
      });
    });
  }

  onDateSelection(e) {
    this.date = e.target.value;
  }

  onFromDateSelection(e) {
    this.fromDate = e.target.value;
  }

  tabLinkChart(element) {

    if (element == 'com_chart' && this.chart_active != 'line') {
      this.implementLineChart(this.getGraphProp(element, this.param_data)); this.chart_active = 'line';
    }

  }

  tabBarChart(element) {
    this.implementBarChart(this.getGraphProp(element, this.param_data)); this.chart_active = 'bar';
    if (this.chart_active != 'bar') {
    }
  }

  exportAsCSV() {
    let data = this.getDataByParam();
    if (data) this.dataShared.exportDataAsCsvFormat(data);
  }

  getDataByParam() {
    return (this.data_param === 'com_chart' || this.data_param === 'table') ? this.tabular_export_data : null;
  }

  exportAsPDF(e) {
    let data = this.getDataByParam();
    if (data) this.dataShared.exportDataAsPdfFormat(data, e, this.data_param_el);
  }

  ngOnDestroy() {
    // Clean up chart when the component is removed
    this.browserOnly(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }
}
